import React from 'react'
import { Row, Col, Form, Radio, Typography } from 'antd'

const { Title } = Typography

const SignatureSettings = ({ quoteSettingsState, setQuoteSettingsState }) => {
	return (
		<Row gutter={30} className={'mb-3'}>
			<Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={24}>
				<Title level={4}>Signature options</Title>
			</Col>

			<Col
				className='gutter-row'
				style={{ paddingTop: '11px' }}
				xs={24}
				sm={12}
				md={12}
				lg={6}
				xl={6}>
				{/* <label className={'text-gray'}>Signature required on delivery</label> */}
			</Col>
			<Col className='gutter-row' xs={24} sm={24} md={24} lg={18} xl={18}>
				<Form.Item className={'mb-0'}>
					<Radio.Group
						name={'signature_settings'}
						value={quoteSettingsState?.signature_settings || 'none'}
						onChange={e =>
							setQuoteSettingsState({
								...quoteSettingsState,
								signature_settings: e.target.value,
							})
						}>
						<Radio style={{ display: 'block' }} value={'none'}>
							Signature not required
						</Radio>
						<Radio style={{ display: 'block' }} value={'signature'}>
							Signature required
						</Radio>
						<Radio style={{ display: 'block' }} value={'adult_signature'}>
							Adult Signature required
						</Radio>
					</Radio.Group>
				</Form.Item>
			</Col>
		</Row>
	)
}

export default SignatureSettings
